import { Badge, Tooltip, Typography } from "antd"
import moment from "moment"
import React from "react"
import { OrderLocation } from "../../Orders/OrderLocation"
import MachineDetails from "./MachineDetails"
import { OrderAndPrefix } from "../../Orders/Helpers/OrderAndPrefix"
import "../../../styles/OrderTable.css"

const { Text, Link } = Typography

//default columns for arsoma waiting table
export const waitingColumns = [
  {
    title: "Nr.",
    dataIndex: "orderNumber",
    align: "center",
    sorter: (a, b) => a.orderNumber - b.orderNumber,
    render: (value, record) => OrderAndPrefix(record),
  },
  {
    title: "Client",
    dataIndex: ["client", "client"],
    align: "center",
    ellipsis: {
      showTitle: false,
    },
    render: (item) => (
      <Tooltip placement="topLeft" title={item}>
        {item}
      </Tooltip>
    ),
  },
  {
    title: "Manager",
    dataIndex: "user",
    ellipsis: {
      showTitle: false,
    },
    align: "center",
    render: (item) => (
      <Tooltip placement="topLeft" title={item}>
        {item}
      </Tooltip>
    ),
  },
  {
    title: "Manufacturer",
    dataIndex: ["manufacturer", "company"],
    align: "center",
  },
  {
    title: "Roll Id",
    dataIndex: ["assignedRollId"],
    align: "center",
    render: (value) => (
      <Text
        copyable={{
          text: value,
        }}>
        roll id
      </Text>
    ),
  },
  {
    title: "Machine",
    dataIndex: ["selectedProduct", "machine"],
    align: "center",
  },
  {
    title: "Material",
    dataIndex: ["selectedProduct", "material"],
    align: "center",
    ellipsis: {
      showTitle: false,
    },
    render: (item) => (
      <Tooltip placement="topLeft" title={item}>
        {item}
      </Tooltip>
    ),
  },
  {
    title: "Location",
    dataIndex: "orderStatus",
    align: "center",
    ellipsis: {
      showTitle: false,
    },
    render: (value) => <Badge status="processing" text={OrderLocation(value)} />,
  },
  {
    title: "Created",
    dataIndex: "created",
    align: "center",
    sorter: (a, b) => a.date.created.seconds - b.date.created.seconds,
    render: (value) => (
      <>
        <Text>{moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>
      </>
    ),
  },
  {
    title: "Proj. M.",
    dataIndex: ["projectedMeters"],
    align: "center",
    key: "projectedMeters",
    filterTitle: "Projected Meters",
    ellipsis: true,
    width: "7%",
    render: (value, record) => <Text>{value}m</Text>,
  },
  {
    title: "Attachment",
    dataIndex: "technicalPage",
    align: "center",
    render: (value) => (
      <Link type="text" rel="noreferrer" target="_blank" href={value}>
        {value ? "Link" : ""}
      </Link>
    ),
  },
  {
    title: "Details",
    align: "center",
    render: (value) => <MachineDetails data={value} />,
  },
]

//default columns for arsoma waiting table
export const sequenceCols = [
  {
    title: "Nr.",
    dataIndex: "orderNumber",
    align: "center",
    sorter: (a, b) => a.orderNumber - b.orderNumber,
    render: (value, record) => OrderAndPrefix(record),
  },
  {
    title: "Client",
    dataIndex: ["client", "client"],
    align: "center",
    ellipsis: {
      showTitle: false,
    },
    render: (item) => (
      <Tooltip placement="topLeft" title={item}>
        {item}
      </Tooltip>
    ),
  },

  {
    title: "Manager",
    dataIndex: "user",
    ellipsis: {
      showTitle: false,
    },
    align: "center",
    render: (item) => (
      <Tooltip placement="topLeft" title={item}>
        {item}
      </Tooltip>
    ),
  },
  {
    title: "Manufacturer",
    dataIndex: ["manufacturer", "company"],
    align: "center",
  },
  {
    title: "Machine",
    dataIndex: ["selectedProduct", "machine"],
    align: "center",
  },
  {
    title: "Material",
    dataIndex: ["selectedProduct", "material"],
    align: "center",
    ellipsis: {
      showTitle: false,
    },
    render: (item) => (
      <Tooltip placement="topLeft" title={item}>
        {item}
      </Tooltip>
    ),
  },
  {
    title: "Location",
    dataIndex: "orderStatus",
    align: "center",
    ellipsis: {
      showTitle: false,
    },
    render: (value) => <Badge status="processing" text={OrderLocation(value)} />,
  },
  {
    title: "Created",
    dataIndex: "created",
    align: "center",
    sorter: (a, b) => a.date.created.seconds - b.date.created.seconds,
    render: (value) => (
      <>
        <Text>{moment.unix(value.seconds).format("DD/MM/YYYY")}</Text>
      </>
    ),
  },
  {
    title: "Attachment",
    dataIndex: "technicalPage",
    align: "center",
    render: (value) => (
      <Link type="text" rel="noreferrer" target="_blank" href={value}>
        {value ? "Link" : ""}
      </Link>
    ),
  },
  {
    title: "Details",
    align: "center",
    render: (value) => <MachineDetails data={value} />,
  },
]
